import { useLogin } from '@refinedev/core';

import { ILoginPayload } from '../model/login';

export const useLoginService = () => {
  const { mutate, isLoading: loadingLogin } = useLogin();

  async function login(values: ILoginPayload): Promise<any> {
    return new Promise((resolve, reject) => {
      mutate(values, {
        onSuccess: (response) => resolve(response),
        onError: (error) => reject(error),
      });
    });
  }

  return {
    login,
    loadingLogin,
  };
};

export default useLoginService;
